module.exports = __webpack_public_path__ + "img/e_3_8_r.5b097e93.png";